module.exports = __webpack_public_path__ + "static/media/nick.f0143ba0.jpg";